export const isInstalled = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(display-mode: standalone)").matches;

// Helper function to check online status
export const checkOnlineStatus = async (): Promise<boolean> => {
  try {
    // Make a small HEAD request to check connectivity
    // Using a small favicon or similar resource is ideal
    const response = await fetch("/favicon.ico", {
      method: "HEAD",
      cache: "no-store",
    });
    return response.ok;
  } catch (_error) {
    // If fetch fails, we're offline
    return false;
  }
};
